import {
  GetCapabilitiesRequest,
  GetCapabilitiesResponse,
  PatrickServiceClient,
} from '@policyfly/protobuf/patrick'

import { devtools } from '@/plugins/devtools/api'

import type { ApiVariableEndpoints, CreateEndpointParams } from '@/stores/api'

export interface CapabilityApiEndpoints {
  /**
   * See {@link GetCapabilitiesRequest}.
   */
  list: (req?: GetCapabilitiesRequest, abortController?: AbortController) => Promise<GetCapabilitiesResponse>
}

export const createCapabilityEndpoints = (params: CreateEndpointParams): ApiVariableEndpoints<CapabilityApiEndpoints> => {
  const patrickServiceClient = new PatrickServiceClient(params.transport)

  const list: CapabilityApiEndpoints['list'] = async (req, abortController) => {
    const request = GetCapabilitiesRequest.create(req)
    const { response } = await patrickServiceClient.getCapabilities(request, { abort: abortController?.signal })

    devtools.logGrpc({
      description: 'Get Capabilities',
      messages: [
        { type: GetCapabilitiesRequest, key: 'request', message: request },
        { type: GetCapabilitiesResponse, key: 'response', message: response },
      ],
    })

    return response
  }

  const endpoints: CapabilityApiEndpoints = {
    list,
  }

  return {
    django: endpoints,
    grpc: endpoints,
  }
}
